// extracted by mini-css-extract-plugin
export var layoutContainer = "_5h-0";
export var layoutContainerNoRounding = "_5h-6";
export var layoutContainerOpen = "_5h-5";
export var layoutContainerResizing = "_5h-1";
export var mainContent = "_5h-2";
export var resizeDivider = "_5h-3";
export var slidePanel = "_5h-4";